import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Player } from 'src/models/player.model';
import { AllScores } from 'src/models/score.model';
import { UserService } from 'src/services/user.service';
import { ScoreService } from '../scores/scores.service';




@Component({
  selector: 'allscores',
  templateUrl: './allscores.component.html',
  styleUrls: ['./allscores.component.scss']
})
export class AllScoresComponent implements AfterViewInit {
  public busy: boolean = true;
  public allScores: AllScores[] = [];
  public player: Player = new Player();
  public debug: boolean = false;

  constructor(private aRoute: ActivatedRoute,
    private userSvc: UserService, private scoreSvc: ScoreService) {
  }

  ngAfterViewInit(): void {
    this.aRoute.queryParams.subscribe(params => this.debug = !!params.debug);

    const p1 = this.userSvc.getUser();
    const p2 = this.scoreSvc.allScores();
    forkJoin([p1, p2]).subscribe(
      (resp) => {
        this.player = new Player(resp[0]);
        this.allScores.length = 0;
        resp[1].forEach(p => {
          const as = new AllScores(p);
          this.allScores.push(as);
        });
        this.busy = false;
      },
      (err) => this.busy = false
    )
  }

}
